// extracted by mini-css-extract-plugin
module.exports = {"row":"discount-lines-totals_row__YVmcL","rowTitle":"discount-lines-totals_rowTitle__59f0Y","rowValue":"discount-lines-totals_rowValue__BJERn"};